
import React from "react";
const HeroSection: React.FC = () => {
  return <div className="flex flex-col md:flex-row items-center gap-6 mb-6">
      <div className="md:w-1/2 space-y-3">
        <h1 className="text-3xl font-playfair font-bold mb-2 text-slate-900">Hard Questions, Biblical Answers.</h1>
        <p className="text-[#403E43]/80 mb-2 text-base">
          Selah helps you defend the faith with Scripture, clarity, and compassion.
        </p>
        <div className="text-[#403E43]/80 text-sm">
          The Theology Answers Tool gives you the language of truth. It answers deep theological questions with biblical authority, logical reasoning, and gospel-centered hope. Every answer is structured, grounded in Scripture, and filled with grace and boldness—reflecting Christ's wisdom.
        </div>
      </div>
      <div className="md:w-1/2">
        <img 
          src="https://bbhhusjprzalcwvkgvsa.supabase.co/storage/v1/object/public/photos//Why%20(1).png" 
          alt="Biblical Defense" 
          className="rounded-lg shadow-md w-full h-72 object-cover object-center" 
        />
      </div>
    </div>;
};
export default HeroSection;
